import { render } from "./training_program.html?vue&type=template&id=4340a963&external"
import script from "./training_program.js?vue&type=script&lang=js&external"
export * from "./training_program.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__